import { render } from "./FullPageLoader.vue?vue&type=template&id=6718cfc3&scoped=true"
import script from "./FullPageLoader.vue?vue&type=script&lang=js"
export * from "./FullPageLoader.vue?vue&type=script&lang=js"

import "./FullPageLoader.vue?vue&type=style&index=0&id=6718cfc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6718cfc3"]])

export default __exports__